module.exports = __webpack_public_path__ + "static/0000-507ce2014b9a290301caa18c0ecf6775.png";